// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"c6954d8e","186":"033a11b2","225":"dfa11a65","344":"5b92ba0d","372":"33b2c88d","573":"b148ca13","738":"482e0e5d","841":"52dcadcf","856":"f7408f89","909":"b1a6afae"}[chunkId] + ".chunk.js";
};